module.exports = __webpack_public_path__ + "static/img/3.7b1399f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/eng/3.png
// module id = ky8A
// module chunks = 0